// PageProjectViewBudget Component

/* eslint indent: 0 */

import React from 'react'
import async from 'async'
import _ from 'lodash'
import HTML5Backend from 'react-dnd-html5-backend'
// import TouchBackend from 'react-dnd-touch-backend';
import { DragDropContext as dragDropContext } from 'react-dnd'

import app from '../../../app.jsx'
import BudgetUtil from '../../../lib/budgetutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import currency from '../../../lib/currency.jsx'
import BudgetAddItem from '../../budget/budget_additem/budget_additem.jsx'
import BudgetContent from '../../budget/budget_content/budget_content.jsx'
import BaseProjectView from '../../page/base_projectview/base_projectview.jsx'
import List from '../../../../components/List/List.jsx'
import ListCell from '../../../../components/ListCell/ListCell.jsx'
import ReportPriceCell from '../../../report/report/report_pricecell/report_pricecell.jsx'
import DNDUtil from '../../../lib/dndutil.jsx'
import Acl from '../../../lib/acl.jsx'
import ExpenseUtil from '../../../lib/expenseutil.js'
import ActionHandler from '../../../lib/actionhandler.jsx'
import ProfilerUtil from '../../../lib/profilerutil.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'
import eventfilters from '../../../lib/eventfilters.jsx'
import { EXPENSE_RATE_CARD } from '../../../../shared/constants.js'
import getRateMarkup from './get_rate_markup'
import routes from '../../../../shared/routes.js'

@dragDropContext(HTML5Backend)
class PageProjectViewBudget extends BaseProjectView {
  constructor (props) {
    super(props, 'projectview-budget', 'project', 'projectview-budget')

    this.data = {
      project: this._getProjectFromCache(this.props.projectId),
      contactId: null,
      budget: null,
      items: null,
      rateCards: [],
      defaultRateCards: [],
      estimateBudget: [],
      estimateIds: [],
      estimateItems: [],
      estimatePhaseList: [],
      estimateActivityList: [],
      pageState: {
        type: 'grid',
        filterType: 'all',
        sort: 'title',
        sortAsc: true
      },
      purchaseorder: null,
      showedit: props.showedit ? props.showedit : '',
      stat: this._getOverviewStatFromCache(this.props.projectId),
      team: app.getTeam(),
      quickbookItems: []
    }

    this.state = {
      profilerId: null
    }

    this._references = {
      budgetContent: React.createRef(),
      budgetItemAdd: React.createRef()
    }
    this.createCommonReference(this._references)

    this._bUnMounted = false
    this._reloadBudgetData = false
    this._setFABButtonState(true, true)
    this._initRealTimeVariables()

    /* Intialize Action handler for budget page */
    this._actionHandler = new ActionHandler('/api/actionhandler/budget')
    this._actionHandler.setDataCallback(this._onActionDataReload.bind(this))
    this._actionHandler.setInitialData({
      projectId: this.props.projectId,
      pageQuery: this._getBudgetPageQuery()
    })

    /* Initialize profiler */
    this._profiler = new ProfilerUtil(this._pageIdent, 3) // Average time 3 seconds
    this._profiler.start()
    this._profiler.setParams(this.props.projectId)
  }

  componentDidMount () {
    this._initEvents()
    BudgetUtil.clearPhaseState()
    app.updatePageTitle('project-view', 'Team')
    this._getData()
    this._initProjectCommonEvents()

    // Init DND scroll events
    DNDUtil.initEvents()

    // Calculate and save profiler, Hardcode profiler id as 1, since it is the first call of profiler
    this._profiler.stop(1)

    /* Load quickbook options for expense */
    this._initQuickbookItems()

    /* Init quickbook events */
    this._initQuickbookExpenseEvents()
  }

  componentWillUnmount () {
    this._bUnMounted = true

    this._releaseEvents()
    this._releaseProjectCommonEvents()

    // Release DND scroll events
    DNDUtil.releaseEvents()

    this._profiler = null

    /* Release quickbook events */
    this._releaseQuickbookExpenseEvents()
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._profiler &&
      (!prevState || prevState.profilerId !== this.state.profilerId) &&
      this.state.profilerId
    ) {
      this._profiler.stop(this.state.profilerId)
    }

    this._reloadBudgetData = false
  }

  _initEvents () {
    this._eventHandlers.purchaseOrderCreated = this._eventReload.bind(
      this,
      'Purchase Order',
      'Created'
    )

    const purchaseOrderService = app.service('/api/purchaseorder')
    purchaseOrderService.on('created', this._eventHandlers.purchaseOrderCreated)
  }

  _releaseEvents () {
    this._releaseTimerEvents()

    const purchaseOrderService = app.service('/api/purchaseorder')
    purchaseOrderService.off(
      'created',
      this._eventHandlers.purchaseOrderCreated
    )

    this._eventHandlers.purchaseOrderService = null
  }

  _eventReload (_objectName, _eventName, eventData) {
    if (this._canRealTimeReload() && eventfilters.teamFilter(eventData)) {
      this._getData()
    }
  }

  getContentClassname () {
    return `${this.data.pageState.type !== 'list' ? 'alt' : ''}`
  }

  renderContent () {
    const _className = `page-projectbudget${
      this.data.pageState.type === 'grid' ? '' : ' list'
    }`
    let showDate = false
    if (
      Acl.isPlannerAllowed() &&
      this.data.project &&
      (this.data.project.startDate || this.data.project.endDate)
    ) {
      showDate = true
    }

    return (
      <div className={_className}>
        {this.data.budget &&
          (this.data.pageState.type === 'grid' ? (
            <BudgetContent
              ref={this._references.budgetContent}
              budget={BudgetUtil.getRenderObject(
                this.data.budget,
                this.data.items
              )}
              contact={this.data.project.contact}
              reloadBudgetData={this._reloadBudgetData}
              user={app.loggedInUserTeam}
              rateCards={this.data.rateCards}
              rate={
                this.data.project && this.data.project.contact
                  ? this.data.project.contact.rate
                  : 0
              }
              rateMarkup={getRateMarkup(this.data.project, this.data.team)}
              estimateBudget={this.data.estimateBudget}
              estimatePhaseList={this.data.estimatePhaseList}
              estimateActivityList={this.data.estimateActivityList}
              introText={this.data.project.introText}
              projectStartDate={
                this.data.project.startDate
                  ? new Date(this.data.project.startDate)
                  : null
              }
              projectEndDate={
                this.data.project.endDate
                  ? new Date(this.data.project.endDate)
                  : null
              }
              projectCloseDate={this.data.project.closeDate}
              projectTitle={this.data.project.title}
              contactName={
                this.data.project && this.data.project.contact
                  ? this.data.project.contact.company
                  : ''
              }
              filterType={this.data.pageState.filterType}
              disabledEdit={this.data.project.status === 'closed'}
              isQuickbookConnected={app.isQuickbookConnected()}
              quickbookItems={this.data.quickbookItems}
              onChange={this._onChangeBudget.bind(this)}
              onItemCreate={this._onItemCreate.bind(this)}
              onItemUpdate={this._onItemUpdate.bind(this)}
              onItemRemove={this._onItemRemove.bind(this)}
              onPhaseRemove={this._onPhaseRemove.bind(this)}
              onPhaseToggle={this._onPhaseToggle.bind(this)}
              onUpdateIntroText={this._onUpdateIntroText.bind(this)}
              onSearchSupplier={BudgetUtil.onSearchSupplier.bind(this)}
              processPhaseSelect={this._processPhaseSelect.bind(this)}
              createNewActivity={this._onCreateNewActivity.bind(this)}
              onCreateItemSupplier={this._onCreateItemSupplier.bind(this)}
              onDeleteItemSupplier={this._onDeleteItemSupplier.bind(this)}
              onCreatePurchaseOrder={this._onCreatePurchaseOrder.bind(this)}
              onViewPurchaseOrder={this._onViewPurchaseOrder.bind(this)}
              onCreateContact={this._onCreateContact.bind(this)}
              calculateSpentAmount={BudgetUtil.calculateSpentAmount}
              onCopyPhase={this._onCopyPhase.bind(this)}
              showDate={showDate}
              calculateMarkupPercentage={BudgetUtil.calculateMarkupPercentage}
              calculateSellingPrice={BudgetUtil.calculateSellingPrice}
              poDownloadBaseUrl={`${routes.PURCHASEORDER_PREVIEW}/${app.getTeamId()}/${app.loggedInId}`}
              onAddExpense={this._onAddExpense.bind(this)}
              onEditExpense={this._onEditExpense.bind(this)}
              teamCountry={app.teamCountry}
              reloadQuickbookItems={this._reloadQuickbookItems.bind(this)}
              onCreateEstimate={this._onCreateEstimate.bind(this)}
              onCreateInvoice={this._onCreateInvoice.bind(this)}
            />
          ) : (
            this._renderList()
          ))}
        {this._renderAddItem()}
        {this._renderExpenseForm()}
      </div>
    )
  }

  _onAddExpense (item, supplier) {
    ExpenseUtil.createExpenseDataFromSupplier(
      this.data.project.contact,
      this.data.project,
      item,
      supplier,
      (expense, items) => {
        if (this._references.expenseForm.current) {
          this._references.expenseForm.current.show(expense, false, items)
        }
      }
    )
  }

  _onEditExpense (expenseId, _supplier) {
    ExpenseUtil.getExpenseDetails(expenseId, (expenseObj, items) => {
      if (expenseObj && this._references.expenseForm.current) {
        this._references.expenseForm.current.show(expenseObj, true, items)
      }
    })
  }

  _onCopyPhase (budget, budgetData, phase, callback) {
    const copyPhaseData = {
      projectId: this.props.projectId,
      budget: BudgetUtil.getSaveObject(budgetData, false).budget,
      items: []
    }

    const newPhase = _.cloneDeep(phase)
    newPhase.id = budget.phases.length
    newPhase.status = 'estimate'
    newPhase.spentAmount = 0
    newPhase.title = `${IntlUtil.convertMessage(
      'common.list.copyNewPhasePrefix'
    )} ${newPhase.title || ''}`

    if (newPhase.groups && newPhase.groups.length > 0) {
      newPhase.groups.map(group => {
        if (group.items && group.items.length > 0) {
          group.items.map((item, itemIdx) => {
            if (item.title !== '') {
              const newItem = BudgetUtil.getNewItemObject(item, false)
              delete newItem.id
              newItem.phaseNo = newPhase.id + 1
              newItem.orderNo = itemIdx + 1
              newItem.spentAmount = 0
              newItem.timeSpent = 0
              newItem.schedules = []
              newItem.allcoatedHours = 0
              newItem.percentage = 0
              newItem.isActive = false

              const suppliers = []
              if (item.type === 'expense-activity') {
                if (item.purchaseOrders && item.purchaseOrders.length > 0) {
                  item.purchaseOrders.map(purchaseOrderObj => {
                    purchaseOrderObj.purchaseOrder = null
                    suppliers.push({ contactId: purchaseOrderObj.contactId })
                  })
                }
              }

              copyPhaseData.items.push({ data: newItem, suppliers: suppliers })
            }
          })
        }
      })
    }

    this._actionHandler.call(
      '/api/project/copyphase',
      'create',
      null,
      copyPhaseData,
      null,
      (copyPhaseErr, copyRes) => {
        if (copyPhaseErr) {
          app.debug('PageProjectViewBudget: _onCopyPhase Error: ', copyPhaseErr)
        } else if (copyRes) {
          callback(
            BudgetUtil.getRenderPhaseObject(
              budget,
              newPhase,
              budget.phases.length,
              copyRes.items
            )
          )
        }
      }
    )
  }

  _reloadQuickbookItems () {
    return app
      .service('/api/quickbook/syncitem')
      .create({})
      .then(itemRes => {
        this.data.quickbookItems = itemRes.data || []
        this.setState({ dataDate: new Date() })
      })
      .catch(err => {
        app.debug('PageprojectViewBudget: _reloadQuickbookItems Error', err)
      })
  }

  _onCreateEstimate () {
    const { project } = this.data
    if (project) {
      const estimateData = {
        projectId: project.id,
        contactId: project.contactId,
        isCreateEstimate: true
      }

      app
        .service('/api/project/estimate')
        .create(estimateData)
        .then(estimateRes => {
          if (estimateRes && estimateRes.estimateId) {
            app.changePage('estimate-view', estimateRes.estimateId)
          }
        })
        .catch(err => {
          app.debug('PageprojectViewBudget: _onCreateEstimate Error', err)
        })
    }
  }

  _onCreateInvoice () {
    const { project } = this.data
    if (project) {
      const invoiceData = {
        contactId: project.contactId,
        projectId: project.id,
        estimateId: null,
        purchaseOrderId: null,
        type: 'based-on-budget',
        referenceNo: '',
        percentage: 100,
        invoiceDate: null,
        dueDate: null,
        budget: {
          phases: [
            {
              title: '',
              total: 0,
              percentage: 0,
              spentAmount: 0
            }
          ],
          totalSpent: 0,
          total: 0
        },
        introText: project.introText
      }
      const params = {
        query: {
          phaseId: '',
          $client: {
            dateMethod: 'entireProject'
          }
        }
      }

      InvoiceUtil.createInvoice(invoiceData, params, (err, res) => {
        if (err) {
          app.debug('PageprojectViewBudget: _onCreateEstimate Error', err)
        } else {
          app.changePage('invoice-view', res.id)
        }
      })
    }
  }

  _triggerEdit () {
    if (this.data.project && this.data.showedit) {
      this.onEditProject()
      this.data.showedit = ''
    }
  }

  _onCreatePurchaseOrder (budgetItem, itemSupplier) {
    const purOrderObj = {
      contactId: itemSupplier.contactId,
      projectId: this.props.projectId,
      description: budgetItem.title,
      status: 'Draft',
      total: budgetItem.total,
      invoiceDate: new Date(),
      createdById: app.loggedInId
    }

    app
      .service('/api/purchaseorder')
      .create(purOrderObj)
      .then(purchaseOrderRes => {
        if (purchaseOrderRes) {
          app.changePage('purchaseorder-view', purchaseOrderRes.id)
        }
      })
      .catch(createErr => {
        app.debug('PageprojectViewBudget: _onClickAddPO createErr', createErr)
      })
  }

  _onCreateContact (contactName, callback) {
    const contactObj = {
      company: contactName,
      addresses: [
        {
          type: 'Office',
          street: '',
          streetNumber: '',
          postcode: '',
          city: '',
          country: app.teamCountry
        }
      ],
      contactPersons: [],
      rateCards: [],
      paymentDays: -1
    }
    app
      .service('/api/contact')
      .create(contactObj)
      .then(contactRes => {
        if (callback) {
          callback(null, contactRes)
        }
      })
      .catch(createErr => {
        app.debug(
          'PageprojectViewBudget: _onClickAddContactErr createErr',
          createErr
        )
        if (callback) {
          callback(createErr, null)
        }
      })
  }

  _onViewPurchaseOrder (purchageOrderId) {
    if (purchageOrderId) {
      app.changePage('purchaseorder-view', purchageOrderId)
    }
  }

  /* Event Handlers */
  _processPhaseSelect (phaseTitle, callback) {
    let estimateItems = []
    const budgetItemService = app.service('/api/project/budgetitem')
    const estBudgets = this.data.estimateBudget

    if (estBudgets && estBudgets.length > 0) {
      estBudgets.map(estBudget => {
        const estimateBudget = BudgetUtil.getRenderObject(
          estBudget,
          this.data.estimateItems
        )

        let selPhase = null
        let phaseIdx = null
        estimateBudget.phases.map((phase, estPhaseIdx) => {
          if (phase.title === phaseTitle) {
            selPhase = phase
            phaseIdx = estPhaseIdx
          }
        })

        if (selPhase) {
          estimateItems = []
          selPhase.groups.map((group, _groupIdx) => {
            group.items.map((groupItem, _itemIdx) => {
              const item = _.cloneDeep(groupItem)
              item.editable = false
              item.bTitleCompleted = true
              item.phaseId = phaseIdx

              delete item.estimateId

              estimateItems.push(item)
            })
          })
        }
      })
    }

    const savedItems = []
    async.map(
      estimateItems,
      (estimateItem, mapDone) => {
        // if (estimateItem.type !== 'subtotal') {
        const createObj = _.cloneDeep(
          BudgetUtil.getNewItemObject(estimateItem, false)
        )
        delete createObj.id

        createObj.groupNo = estimateItem.groupNo
        createObj.orderNo = estimateItem.orderNo
        createObj.contactId = this.data.contactId
        createObj.projectId = this.props.projectId

        budgetItemService
          .create(createObj)
          .then(createItemRes => {
            if (createItemRes) {
              savedItems.push(createItemRes)
              mapDone(null)
            }
          })
          .catch(createItemErr => {
            mapDone(createItemErr)
            app.debug(
              'PageProjectViewBudget: _processPhaseSelect err',
              createItemErr
            )
          })
        // }
      },
      err => {
        if (err) {
          callback([]) // eslint-disable-line standard/no-callback-literal
        }

        callback(savedItems)
      }
    )
  }

  _getBudgetPageData () {
    const params = {
      query: this._getBudgetPageQuery()
    }
    return app.service('/api/page/project/budget').find(params)
  }

  _getBudgetPageQuery () {
    return {
      pageState: this.data.pageState,
      pageIdent: this._pageIdent,
      projectId: this.props.projectId,
      bGetQuickbookItem: app.isQuickbookConnected(),
      project: {
        $client: {
          subObjects: {
            contact: ['company', 'rateCards', 'rateMarkup', 'rate']
          }
        }
      },
      budgetItem: {
        projectId: this.props.projectId,
        $sort: { orderNo: 1 },
        $client: {
          getPurchaseOrderClients: true,
          subObjects: {
            bUsed: true
          }
        }
      },
      estimate: {
        projectId: this.props.projectId
      },
      estimateItem: {
        $sort: { orderNo: 1 },
        $client: {
          getPurchaseOrderClients: true
        }
      }
    }
  }

  _getData () {
    // Start profiler
    const profilerId = this._profiler ? this._profiler.start() : 0

    this._setDataLoading()

    return this._getBudgetPageData()
      .then(result => {
        this._onPageDataRecieved(result.pageData)

        if (result.project) {
          this.data.project = result.project
          this._setProjectToCache(this.data.project)
        }

        if (result.estimates && result.estimates.total > 0) {
          result.estimates.data.map(estimate => {
            this.data.estimateIds.push(estimate.id)

            const budget = estimate.budget

            if (budget && budget.phases && budget.phases.length > 0) {
              budget.phases.map(phase => {
                this.data.estimatePhaseList.push({
                  label: phase.title,
                  value: phase.title
                })
              })

              this.data.estimateBudget.push(budget)
            }
          })
        }

        if (result.stat) {
          this.data.stat = result.stat
          this._setOverviewStatToCache(this.data.stat)
        }

        this.data.items = result.budgetItems
        this.data.estimateItems = result.estimateItems
        this.data.defaultRateCards = result.defaultRateCards
        this.data.quickbookItems = result.quickbookItems || []

        this._reloadBudgetData = true
        this._onDataReceived(null, profilerId)
        this.forceUpdate()
      })
      .catch(err => {
        app.debug('PageProjectViewBudget: _getData ERROR', err)
        this._onDataReceived(err, profilerId)
      })
  }

  _onDataReceived (err, profilerId) {
    if (this._bUnMounted) return

    this._setDataLoaded()

    if (err) {
      app.debug('PageProjectBudget: _onDataReceived Error', err)

      this._setFABButtonVisible(false)
      this.setState({
        loading: true,
        dataDate: new Date(),
        profilerId: profilerId
      })
    } else {
      app.debug('PageProjectBudget: _onDataReceived [done]')

      // Get the budget phase states and use it
      const userState = this._pageData.userState
      let phaseState = {}
      if (
        userState &&
        userState.state &&
        userState.state.projectPhaseState &&
        userState.state.projectPhaseState[this.data.project.id] !== undefined
      ) {
        phaseState = userState.state.projectPhaseState[this.data.project.id]
      }
      BudgetUtil.setPhaseState(phaseState)

      this.data.contactId = this.data.project.contactId
      this.data.budget = this.data.project.budget
      if (!this.data.budget) {
        this.data.budget = BudgetUtil.createEmptyBudget()
      }

      this.data.rateCards = []
      const rateCards =
        this.data.project.contact && this.data.project.contact.rateCards
          ? this.data.project.contact.rateCards
          : []

      if (rateCards && rateCards.length > 0) {
        rateCards.map(rateCard => {
          const rateCardObj = {
            ...rateCard,
            label: this._formRateCardLabel(rateCard, false),
            value: rateCard.name,
            amount: rateCard.amount,
            labelHasHtml: true
          }

          this.data.rateCards.push(rateCardObj)
        })
      }

      if (this.data.defaultRateCards && this.data.defaultRateCards.length > 0) {
        this.data.defaultRateCards.map(defRateCard => {
          const rateCardObj = {
            ...defRateCard,
            label: this._formRateCardLabel(defRateCard, true),
            value: defRateCard.name,
            amount: defRateCard.amount,
            labelHasHtml: true
          }
          // check if the rate card exists in contact specific ones
          const defaultRateExists =
            this.data.project.contact && this.data.project.contact.rateCards
              ? !this.data.project.contact.rateCards.find(
                  ({ name }) => name === defRateCard.name
                )
              : true
          defaultRateExists && this.data.rateCards.push(rateCardObj)
        })
      }

      const pageState = this.data.pageState
      if (this.data.project.status === 'closed' || pageState.type === 'list') {
        this._setFABButtonVisible(false)
      } else {
        this._setFABButtonVisible(true)
      }

      this.setState({
        loading: !this.data.project,
        dataDate: new Date(),
        profilerId: profilerId
      })

      app.updatePageTitle(
        'projectview-team',
        this.data.project ? this.data.project.title : ''
      )
      this._triggerEdit()
    }
  }

  _formRateCardLabel (rateCard, bGlobal) {
    return `<span className="label">
        <span className="title">${rateCard.name}</span>
        <span className="type">
          ${
            bGlobal
              ? IntlUtil.convertMessage('project.viewBudget.globalRateCard') +
                ' - '
              : IntlUtil.convertMessage('project.viewBudget.ratecardPrefix') +
                ' - '
          }
          ${currency.formatSymbol(rateCard.amount)} p/u
          ${
            rateCard.type === EXPENSE_RATE_CARD
              ? ` - ${rateCard.markupPercentage} %`
              : ''
          }
        </span>
      </span>`
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        type: pageState.type || 'grid',
        filterType: pageState.filterType || 'all',
        sort: pageState.sort || 'title',
        sortAsc: pageState.sortAsc !== false
      }
    }
  }

  // Called when item title completed
  _onItemCreate (item) {
    /* if (item.type === 'subtotal') {
      return false;
    } */

    const createObj = BudgetUtil.getNewItemObject(item, false)
    delete createObj.id

    createObj.contactId = this.data.contactId
    createObj.projectId = this.props.projectId

    const requestQueueId = this._actionHandler.call(
      '/api/project/budgetitem',
      'create',
      null,
      createObj,
      null,
      (createItemErr, createItemRes) => {
        if (createItemErr) {
          app.debug('PageProjectViewBudget: _onItemCreate err', createItemErr)
        } else if (createItemRes) {
          item.id = createItemRes.id
          item.contactId = createItemRes.contactId
          item.projectId = createItemRes.projectId
        }
      }
    )

    if (!item.tempId) {
      item.tempId = requestQueueId
    }
  }

  // Called when item title, date, description, po - all cases if total save is not called
  _onItemUpdate (item, attribute, callback) {
    if (!item.id) {
      /* || item.type === 'subtotal') { */
      return false
    }

    const updateObj = BudgetUtil.getUpdateItemObject(item, attribute)
    const params = {
      query: {
        $client: {
          excludeSpend: true
        }
      }
    }

    this._actionHandler.call(
      '/api/project/budgetitem',
      'patch',
      item.id,
      updateObj,
      params,
      (updItemErr, _updItemRes) => {
        if (updItemErr) {
          app.debug('PageProjectViewBudget: _onItemUpdate err', updItemErr)
          if (callback) {
            callback(updItemErr)
          }
        } else {
          if (callback) {
            callback(null)
          }
        }
      }
    )
  }

  _onItemRemove (item) {
    if (!item.id) {
      /* || item.type === 'subtotal' */
      return false
    }

    this._actionHandler.call(
      '/api/project/budgetitem',
      'remove',
      item.id,
      null,
      null,
      (remItemErr, _remItemRes) => {
        if (remItemErr) {
          app.debug('PageProjectViewBudget: _onItemRemove err', remItemErr)
        }
      }
    )
  }

  _onPhaseRemove (phaseId, removeData, callback) {
    BudgetUtil.deletePhaseFromState(phaseId)

    this._actionHandler.call(
      '/api/common/removephase',
      'create',
      null,
      removeData,
      null,
      (removeErr, _res) => {
        if (removeErr) {
          app.debug('PageProjectViewBudget: _onPhaseRemove err', removeErr)
        } else {
          callback(null)
        }
      }
    )
  }

  _onPhaseToggle (budget) {
    BudgetUtil.getSaveObject(budget, false)
    this._updatePhaseState(this.props.projectId, null)
  }

  _onChangeBudget (budgetObj, closeDate) {
    const saveObj = BudgetUtil.getSaveObject(budgetObj, false)
    const updateObj = {
      budget: saveObj.budget
    }
    if (closeDate) {
      updateObj.closeDate = closeDate
    }

    this.data.stat.invoiceInfo.sellingTotal =
      saveObj && saveObj.budget && saveObj.budget.totalSellingPrice

    // This line is used to trigger the PageHeader component to re-render
    this.setState({ dataDate: new Date() })

    async.series(
      [
        done => {
          this._actionHandler.call(
            '/api/project',
            'patch',
            this.props.projectId,
            updateObj,
            null,
            (prjErr, _prjRes) => {
              if (prjErr) {
                done(prjErr)
              } else {
                /* Always Reload if budget updated */
                this._isDataLoading = false
                this._lastReloadTime = null

                done(null)
              }
            }
          )
        }
        /* (done) => {
        this._saveBudgetItems(this.props.projectId, saveObj.items, done);
      } */
      ],
      (asynErr, _asyncRes) => {
        if (asynErr) {
          app.debug('PageProjectViewBudget: _onChangeBudget err', asynErr)
        } else {
          this.data.estimateBudget = []
          this.data.estimateIds = []
          this.data.estimateItems = []
          this.data.estimatePhaseList = []
          this.data.estimateActivityList = []
        }
      }
    )
  }

  _saveBudgetItems (projectId, items, callback) {
    const budgetItemService = app.service('/api/project/budgetitem')
    const contactId = this.data.contactId

    async.map(
      items,
      (item, mapDone) => {
        const updateId = item.id

        const updateItem = _.cloneDeep(item)
        updateItem.contactId = contactId
        delete updateItem.id

        if (updateId) {
          budgetItemService
            .patch(updateId, updateItem)
            .then(_updItemRes => {
              mapDone(null)
            })
            .catch(updItemErr => {
              mapDone(updItemErr)
              app.debug(
                'PageProjectViewBudget: _saveBudgetItems err',
                updItemErr
              )
            })
        }
      },
      (asyncErr, _asyncRes) => {
        if (asyncErr) {
          callback(asyncErr)
        } else {
          callback(null)
        }
      }
    )
  }

  _updatePhaseState (projectId, callback) {
    const updateObj = {
      state: this._pageData.userState.state || {}
    }

    if (updateObj.state.projectPhaseState === undefined) {
      updateObj.state.projectPhaseState = {}
    }

    updateObj.state.projectPhaseState[projectId] = BudgetUtil.getPhaseState()

    if (this._pageData.userState.id) {
      app
        .service('/api/user/state')
        .patch(this._pageData.userState.id, updateObj, {})
        .then(result => {
          this._pageData.userState = result

          if (callback) {
            callback(null)
          }
        })
        .catch(err => {
          app.debug('PageProjectViewBudget: _updatePhaseState err', err)
          if (callback) {
            callback(null)
          }
        })
    } else {
      const createObj = {
        userId: app.loggedInId,
        state: updateObj.state
      }

      app
        .service('/api/user/state')
        .create(createObj)
        .then(result => {
          this._pageData.userState = result

          if (callback) {
            callback(null)
          }
        })
        .catch(err => {
          app.debug('PageProjectViewBudget: _createUserState err', err)
          if (callback) {
            callback(null)
          }
        })
    }
  }

  _onUpdateIntroText (introText, callback) {
    this._actionHandler.call(
      '/api/project',
      'patch',
      this.props.projectId,
      { introText: introText },
      null,
      (prjErr, _prjRes) => {
        if (prjErr) {
          app.debug('PageProjectViewBudget: _onUpdateIntroText Error', prjErr)
        } else {
          if (callback) {
            callback(null)
          }
        }
      }
    )
  }

  onFABClose () {
    if (this._references.budgetItemAdd.current) {
      this._references.budgetItemAdd.current.hide()
    }
  }

  onAdd () {
    if (this._references.budgetItemAdd.current) {
      this._references.budgetItemAdd.current.show()
    }
  }

  _onFABBudgetAddClose () {
    this._hideCloseFABButton()
  }

  _onAddActivity (type, ev) {
    ev.preventDefault()

    if (this.data.pageState.filterType !== 'all' && type === 'text') {
      this.data.pageState.filterType = 'all'

      this._updatePageState(this.data.pageState)
      this.forceUpdate()
    } else if (
      this.data.pageState.filterType === 'time' &&
      type === 'expense-activity'
    ) {
      this.data.pageState.filterType = 'all'

      this._updatePageState(this.data.pageState)
      this.forceUpdate()
    } else if (
      this.data.pageState.filterType === 'expense' &&
      type === 'time-activity'
    ) {
      this.data.pageState.filterType = 'all'

      this._updatePageState(this.data.pageState)
      this.forceUpdate()
    }

    this.onFABClose()
    if (this._references.budgetContent.current) {
      this._references.budgetContent.current.onAddActivity(type)
    }
  }

  _onAddPhase (ev) {
    ev.preventDefault()

    this.onFABClose()
    if (this._references.budgetContent.current) {
      this._references.budgetContent.current.addPhase()
    }
  }

  _onAddIntroText (ev) {
    ev.preventDefault()

    this.onFABClose()
    if (this._references.budgetContent.current) {
      this._references.budgetContent.current.showIntroEditor(true)
    }
  }

  _onCreateNewActivity (budget, type, phase, groupId) {
    let rateMarkup = 0
    let rate = 0
    if (this.data.project && this.data.project.contact) {
      rateMarkup = this.data.project.contact.rateMarkup
      rate = this.data.project.contact.rate
    }

    return BudgetUtil.createNewActivity(
      budget,
      type,
      phase,
      groupId,
      false,
      0,
      rateMarkup,
      rate
    )
  }

  _onCreateItemSupplier (itemSupplier, callback) {
    itemSupplier.projectId = this.props.projectId
    this._actionHandler.call(
      '/api/project/budgetitemsupplier',
      'create',
      null,
      itemSupplier,
      null,
      (createErr, createRes) => {
        if (createErr) {
          app.debug(
            'PageProjectViewBudget: _onCreateItemSupplier Error',
            createErr
          )
        } else {
          if (callback) {
            callback(createRes)
          }
          this._getData()
        }
      }
    )
  }

  _onDeleteItemSupplier (itemSupplierId) {
    if (!itemSupplierId) {
      return false
    }

    this._actionHandler.call(
      '/api/project/budgetitemsupplier',
      'remove',
      itemSupplierId,
      null,
      null,
      (removeErr, _removeRes) => {
        if (removeErr) {
          app.debug(
            'PageProjectViewBudget: _onDeleteItemSupplier Error',
            removeErr
          )
        } else {
          this._getData()
        }
      }
    )
  }

  _onChangeFilter (filter) {
    if (filter) {
      this.data.pageState.type = filter.budgetContentType
      this.data.pageState.filterType = filter.budgetFilterType
      this._updatePageState(this.data.pageState)
    }

    // Dont show FAB button for list
    if (filter.budgetContentType === 'list') {
      this._setFABButtonVisible(false)
    } else {
      this._setFABButtonVisible(true)
    }

    this.forceUpdate()
  }

  /* List Events */
  _onSort (sort, sortAsc) {
    this.data.pageState.sort = sort
    this.data.pageState.sortAsc = sortAsc
    this._updatePageState(this.data.pageState)

    this.forceUpdate()
  }

  /* Private functions */
  _renderAddItem () {
    if (this.data.project) {
      return (
        <BudgetAddItem
          ref={this._references.budgetItemAdd}
          filterType={this.data.pageState.filterType}
          onClose={this._onFABBudgetAddClose.bind(this)}
          onTimeActivityAdd={this._onAddActivity.bind(this, 'time-activity')}
          onExpenseActivityAdd={this._onAddActivity.bind(
            this,
            'expense-activity'
          )}
          onTextAdd={this._onAddActivity.bind(this, 'text')}
          onSubtotalAdd={this._onAddActivity.bind(this, 'subtotal')}
          onPhaseAdd={this._onAddPhase.bind(this)}
          onIntroTextAdd={this._onAddIntroText.bind(this)}
        />
      )
    }

    return ''
  }

  _onAfterSaveExpense () {
    return this._getBudgetPageData()
      .then(result => {
        if (this._references.budgetContent.current) {
          this._references.budgetContent.current.refreshDataItems(
            BudgetUtil.getRenderObject(
              result.project.budget,
              result.budgetItems
            ),
            result.budgetItems
          )
        }
        if (this._references.expenseForm.current) {
          this._references.expenseForm.current.hide()
        }
      })
      .catch(err => {
        app.debug('PageProjectViewBudget: _onAfterSaveExpense ERROR', err)
        if (this._references.expenseForm.current) {
          this._references.expenseForm.current.hide()
        }
      })
  }

  _getHeaderFilter () {
    return this.data.pageState
  }

  _renderList () {
    let items = _.cloneDeep(this.data.items)
    const filterType = this.data.pageState.filterType

    // Process filter
    if (filterType === 'expense') {
      items = _.filter(items, obj => obj.type === 'expense-activity')
    } else if (filterType === 'time') {
      items = _.filter(items, obj => obj.type === 'time-activity')
    } else {
      items = _.filter(
        items,
        obj => obj.type === 'time-activity' || obj.type === 'expense-activity'
      )
    }

    // Process sorting
    let sortByField = this.data.pageState.sort
    if (this.data.pageState.sort === 'totalbudget') {
      sortByField = 'total'
    }

    items = _.sortBy(items, sortByField)

    if (this.data.pageState.sortAsc) {
      items.reverse()
    }

    return (
      <div className='listwrap'>
        <List
          objectList={items}
          sortOptions={this._getSortOptions()}
          columns={this._getListCloumns()}
          onSort={this._onSort.bind(this)}
          renderCustomCell={this._onRenderList.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
        />
      </div>
    )
  }

  _getSortOptions () {
    return []
  }

  _getListCloumns () {
    return [
      {
        label: 'project.viewBudgetList.title',
        identifier: 'title',
        width: '16%',
        sort: true,
        type: 'text'
      },
      {
        label: 'project.viewBudgetList.supplier',
        identifier: 'supplier',
        width: '13%',
        sort: true,
        type: 'custom',
        customType: 'supplier'
      },
      {
        label: 'project.viewBudgetList.sellingPrice',
        identifier: 'total',
        width: '16%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'project.viewBudgetList.hours',
        identifier: 'noHours',
        width: '10%',
        sort: true,
        type: 'text'
      },
      {
        label: 'project.viewBudgetList.rate',
        identifier: 'pricePerHour',
        width: '10%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'project.viewBudgetList.budget',
        identifier: 'totalbudget',
        width: '11%',
        sort: true,
        type: 'custom',
        customType: 'total'
      },
      {
        label: 'project.viewBudgetList.spentAmount',
        identifier: 'spentAmount',
        width: '10%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'project.viewBudgetList.purchaseOrder',
        identifier: 'purchaseOrder',
        width: '14%',
        sort: true,
        type: 'custom',
        customType: 'purchaseOrder'
      }
    ]
  }

  _onRenderList (activity, column, idx) {
    let value = activity[column.identifier]
    let colType = column.type

    if (column.identifier === 'total') {
      if (activity.type === 'expense-activity') {
        return <ReportPriceCell price={value} width={column.width} key={idx} />
      }
    } else if (column.identifier === 'pricePerHour') {
      if (!activity.bUseTotal) {
        return <ReportPriceCell price={value} width={column.width} key={idx} />
      }
    } else if (column.customType === 'price') {
      return <ReportPriceCell price={value} width={column.width} key={idx} />
    } else if (column.customType === 'supplier' && activity.purchaseOrders) {
      colType = 'text'
      const contactNames = []
      activity.purchaseOrders.map(obj => {
        if (obj.contact) {
          contactNames.push(obj.contact.title)
        }
      })

      if (contactNames.length > 0) {
        value = contactNames.join(', ')
      }
    } else if (
      column.customType === 'purchaseOrder' &&
      activity.purchaseOrders
    ) {
      colType = 'text'
      const poNos = []
      activity.purchaseOrders.map(obj => {
        if (obj.purchaseOrder) {
          poNos.push(obj.purchaseOrder.invoiceNo)
        }
      })

      if (poNos.length > 0) {
        value = poNos.join(', ')
      }
    } else if (column.customType === 'total') {
      let total = activity.total
      if (activity.type === 'time-activity' && !activity.bUseTotal) {
        total = activity.noHours * activity.pricePerHour
      }

      return <ReportPriceCell price={total} width={column.width} key={idx} />
    }

    return (
      <ListCell key={idx} value={value} type={colType} width={column.width} />
    )
  }

  _onActionDataReload (resultData) {
    app.debug('-- Event - PageProjectViewBudget - _onActionDataReload --')
    if (resultData) {
      if (resultData.project) {
        this.data.project = resultData.project
        this.data.budget = this.data.project.budget
        if (!this.data.budget) {
          this.data.budget = BudgetUtil.createEmptyBudget()
        }

        if (
          this.data.project.status === 'closed' ||
          this.data.pageState.type === 'list'
        ) {
          this._setFABButtonVisible(false)
        } else {
          this._setFABButtonVisible(true)
        }

        this._setProjectToCache(this.data.project)
      }

      if (resultData.items) {
        this.data.items = resultData.items
      }

      this.setState({ dataDate: new Date() })
    }
  }

  /* Header Functions - Start */
  _onHeaderGridListToggle (isGridActive) {
    this.data.pageState.type = isGridActive ? 'grid' : 'list'
    this._updatePageState(this.data.pageState)

    // Dont show FAB button for list
    if (isGridActive) {
      this._setFABButtonVisible(true)
    } else {
      this._setFABButtonVisible(false)
    }

    this.setState({ dataDate: new Date() })
  }

  _onHeaderContentFilter (option) {
    this.data.pageState.filterType = option.ident
    this._updatePageState(this.data.pageState)

    this.setState({ dataDate: new Date() })
  }
  /* Header Functions - End */
}

export default PageProjectViewBudget
